import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {
  Box,
  CircularProgress,
  Divider,
  Grid,
  Link,
  Typography
} from '@mui/material';
import { DateTime } from 'luxon';
import { ReactComponent as ZTLoginPageLogo } from './images/ZT_Logo_Horizontal.svg';
import img from './images/Marketing_Image.png';

const useStyles = makeStyles((theme) => ({
  image: {
    height: theme.spacing(60),
    width: theme.spacing(60)
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    height: '100%',
    marginBottom: theme.spacing(0)
  },
  gridContent: {
    marginRight: theme.spacing(3)
  },
  logo: {
    marginBottom: theme.spacing(2)
  },
  circularProgress: {
    margin: theme.spacing(5, 0, 6, 0)
  },
  divider: {
    width: '90%',
    color: theme.palette.grey[700],
    borderBottomWidth: theme.spacing(0.2)
  },
  bodyMessage: {
    fontWeight: 600,
    marginTop: theme.spacing(1)
  },
  text: {
    whiteSpace: 'nowrap',
    ...theme.typography.body1
  },
  bodyDiv: {
    marginBottom: theme.spacing(3)
  },
  repliconFooter: {
    color: theme.palette.text.primary,
    fontFamily: theme.typography.body1.fontFamily,
    alignSelf: 'center',
    padding: theme.spacing(4, 0)
  },
  bottomBar: {
    display: 'flex',
    backgroundColor: '#110434',
    height: theme.spacing(7.5),
    justifyContent: 'space-around',
    alignItems: 'center',
    color: theme.palette.common.white,
    padding: theme.spacing(0, 18.5),
    position: 'fixed',
    bottom: theme.spacing(0),
    width: '100%'
  },
  textGridContainer: {
    marginTop: theme.spacing(12)
  },
  subText: {
    color: theme.palette.text.primary
  }
}));

const LoadingLoginUiCircular = () => {
  const classes = useStyles();
  const copyrightYear = DateTime.local().year;
  return (
    <Box>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        className={classes.container}
      >
        <Grid item xs={1.5}></Grid>
        <Grid
          item
          xs={5}
          container
          alignItems="flex-start"
          direction="column"
          justifyContent="center"
          className={classes.textGridContainer}
        >
          <div className={classes.logo}>
            <ZTLoginPageLogo />
          </div>
          <div className={classes.subText}>
            <Typography variant="h4">
              Freedom! No More Manual Time Tracking.
            </Typography>
            <Typography variant="h4">Let ZeroTime Do It for You.</Typography>
          </div>
          <CircularProgress className={classes.circularProgress} />
          <Divider className={classes.divider} />
          <div>
            <Typography variant="body1" className={classes.bodyMessage}>
              Need Assistance? Call us toll free!
            </Typography>
            <Grid container item direction="row" className={classes.bodyDiv}>
              <Grid item xs={8}>
                <Typography variant="body1" className={classes.text}>
                  North America
                </Typography>
                <Typography variant="body1" className={classes.text}>
                  Other Countries
                </Typography>
                <Typography variant="body1" className={classes.text}>
                  Email us at
                </Typography>
              </Grid>
              <Grid item xs={4} justifyContent="center">
                <Typography className={classes.text}>1-877-862-2519</Typography>
                <Typography className={classes.text}>+800-8622-5192</Typography>
                <Link
                  href="mailto:support@replicon.com"
                  className={classes.text}
                >
                  support@replicon.com
                </Link>
              </Grid>
            </Grid>
            <Typography
              className={classes.repliconFooter}
              color="textSecondary"
            >
              Replicon Inc, © 1996 - {copyrightYear}
            </Typography>
          </div>
        </Grid>
        <Grid
          item
          container
          xs={5.5}
          alignItems="center"
          justifyContent="flex-start"
        >
          <img src={img} alt="Logo" className={classes.image} />
        </Grid>
      </Grid>
      <div className={classes.bottomBar}>
        <Typography variant="body2">
          Trusted by 3000+ Global Businesses
        </Typography>
        <Typography variant="body2">|</Typography>
        <Typography variant="body2">
          loginPage.footerMessage2Get 100% Accurate Time and Work Data
        </Typography>
        <Typography variant="body2">|</Typography>
        <Typography variant="body2">
          Gain up to 10-15% Increase in Employee Productivity
        </Typography>
      </div>
    </Box>
  );
};

export default LoadingLoginUiCircular;
